module.exports = __webpack_public_path__ + "static/media/nr.0b3b5997.svg";